import { useRef } from "react";
import CreateAlertModal, {
  CreateAlertModalRef,
} from "../../components/alerts/CreateAlertModal";

import styles from "./Alerts.module.scss";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../components/common/PrimaryButton";
import { PrimaryButtonSize } from "../../components/common/PrimaryButton/PrimaryButton";
import AlertsTable from "../../components/alerts/AlertsTable";
import classNames from "classnames";

const Alerts = () => {
  const { t } = useTranslation();
  const createAlertModalRef = useRef<CreateAlertModalRef>(null);
  return (
    <div className={classNames(styles.page_layout, styles.alerts_page)}>
      <div className={styles.alerts_container}>
        <div className={styles.header}>
          <h1>{t("lbl_alerts")}</h1>
          <div className={styles.button_container}>
            <PrimaryButton
              size={PrimaryButtonSize.REGULAR}
              onClick={() => createAlertModalRef.current?.openModal()}
              backgroundColor="black">
              <p className={styles.button_text}>{t("add_alert")}</p>
            </PrimaryButton>
          </div>
        </div>
        <p className={styles.subtitle}>{t("lbl_alerts_management")}</p>
        <AlertsTable />
        <CreateAlertModal
          ref={createAlertModalRef}
          title={t("create_alert_modal_title")}
        />
      </div>
    </div>
  );
};

export default Alerts;
